import axios from "axios";

export async function createUser(data) {
  try {
    let response = await axios.post(
      `${process.env.SERVER_BASE_URL}/durga-puja-2025/user/create`,
      data
    );
    return response?.data;
  } catch (error) {
    console.log(error);

    if (error?.response?.status === 409) {
      return {
        user: error?.response?.data?.user,
        error: "User already exists",
      };
    }

    return null;
  }
}
